'use client'

import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { MobilePageTemplate } from '@/components/templates'
import styles from '@/features/Auth/ui/AuthWalletConnected/AuthWalletConnected.module.scss'
import { Button, Flex } from 'antd'
import Link from 'next/link'

export default function NotFound() {
  return (
    <MobilePageTemplate withTabs={false}>
      <Flex vertical justify="center" align="center" className="mobileContainer">
        <Flex className="w-full" flex={1} gap={15} justify="center" vertical align="center">
          <span className={styles.icon} style={{ fontSize: 80 }}>🔎️</span>
          <AppTitle text="Oops!" centered />
          <p className={styles.text}>Page not found</p>
        </Flex>
        <Link href="/" className="w-full" style={{ display: 'block' }}>
          <Button className={styles.button} type="primary" size="large">
            Go home
          </Button>
        </Link>
      </Flex>
    </MobilePageTemplate>
  )
}
